<section tuiContent>
	@if (error(); as err) {
		<div tuiNotification class="mb-2" size="s" appearance="negative">
			{{ err | transloco }}
		</div>
	}

	@if (form) {
		<form
			[formGroup]="form"
			(ngSubmit)="onSubmit()"
			(keyup.enter)="onSubmit()"
		>
			<label tuiLabel>
				{{ 'data.email' | transloco }}
				<tui-textfield tuiTextfieldSize="m">
					<input
						formControlName="email"
						tuiInput
						readonly
						autocomplete="email"
					/>
				</tui-textfield>
			</label>

			<label tuiLabel>
				{{ 'data.password' | transloco }}
				<tui-textfield tuiTextfieldSize="m">
					<input
						tuiInput
						formControlName="password"
						type="password"
						autocomplete="current-password"
					/>
					<tui-icon tuiPassword />
				</tui-textfield>
				<tui-error formControlName="password" [order]="['required']" />
			</label>
		</form>
	}
</section>

<footer tuiFooter>
	<button tuiButton appearance="outline" type="button" (click)="onCancel()">
		{{ 'action.cancel' | transloco }}
	</button>
	<button
		tuiButton
		type="submit"
		appearance="accent"
		(click)="onSubmit()"
		[disabled]="busy()"
		[loading]="busy()"
	>
		{{ 'auth.sign-in' | transloco }}
	</button>
</footer>
